module.exports = __webpack_public_path__ + "img/1696321820957-WhatsApp Image 2023-10-03 at 16.27.55.jpeg.93ab180a.webp";